var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"update"},[_vm._v("截止"+_vm._s(_vm.lastUpdateTime)+"，共"+_vm._s(_vm.total)+"条数据")])}
var staticRenderFns = []

export { render, staticRenderFns }